//import { AnalyticsProvider } from './../../../../../providers/analytics/analytics';
import { Component, NgZone, ViewChild } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version';
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { Camera } from '@ionic-native/camera';
import { Diagnostic } from '@ionic-native/diagnostic';
import { FileTransfer } from '@ionic-native/file-transfer';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import {
  ActionSheetController,
  AlertController,
  Events,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform, PopoverController, Slides, ViewController
} from 'ionic-angular';
import _ from 'lodash';
import moment from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { PollingBloc } from '../../../../../bloc/feature/polling/polling.bloc';
import { ProfileBloc } from '../../../../../bloc/feature/profile/profile.bloc';
import { AttendanceFaceBloc } from '../../../../../bloc/hr/attendance/attendance-face.bloc';
import { AttendanceTempBloc } from '../../../../../bloc/hr/attendance/attendance-temp.bloc';
import { AttendanceBloc } from '../../../../../bloc/hr/attendance/attendance.bloc';
import { EventNameAnalytics } from '../../../../../helpers/event-name-analytics';
import { AttendancePreviewData } from '../../../../../model/attendance/attendance-preview.model';
import { GDAuthInterface } from '../../../../../model/gd-auth';
import { PageBuilderSubmenuApiProvider } from '../../../../../pagebuilder/services/menu/submenu/pagebuilder-submenu-api';
import { AnalyticsProvider } from "../../../../../providers/analytics/analytics";
import { CustomPluginProvider } from '../../../../../providers/custom-plugin/custom-plugin';
import { SFGOAuthService } from '../../../../../providers/sfgoauth.service/sfgoauth.service';
import { SettingApi } from '../../../../../shared/nestjs/gd-all-in-one/services/setting.api';
import { RequestGetEmpDto } from '../../../../../shared/nestjs/gd-only/dto/sf-profile.dto';
import { SFAttendanceSF6Api } from "../../../../../shared/sdk/services/custom";
import { SunfishApi } from '../../../../../shared/sdk/services/custom/Sunfish';
import { AlertServiceProvider } from './../../../../../providers/alert-service/alert-service';
import { PermissionCheckProvider } from './../../../../../providers/permission-check/permission-check';
import { StoragePathProvider } from "./../../../../../providers/storage-path/storage-path";
import { ToastServiceProvider } from './../../../../../providers/toast-service/toast.service';
import { LoopBackConfig } from './../../../../../shared/sdk/lb.config';
import { SettingServiceApi } from './../../../../../shared/sdk/services/custom/SettingService';
import { SFAttendanceApi } from './../../../../../shared/sdk/services/custom/SFAttendance';

//declare var window: any;
/**
 * Generated class for the TimeAttendanceSfgoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-time-attendance-sfgo',
  templateUrl: 'time-attendance-sfgo.html',
})
export class TimeAttendanceSfgoPage {
  @ViewChild('fileInput') fileInput;
  @ViewChild(Slides) slides: Slides;

  toggleNext: boolean = true;
  togglePrev: boolean = false;

  public isProfile = false;
  public SFGoAuth: GDAuthInterface;

  public newendtime: any;
  public newshiftcode: any;
  public newshiftname: any;
  public newshiftend: any;
  public newshiftstart: any;
  public newstarttime: any = null;
  public disabledStart = false;
  public disabledEnd = false;
  public btnDisabled = true;

  public clockIn: any = null;
  public clockOut: any = null;
  public actualClockIn: any = null;
  public actualClockOut: any = null;
  public startDegree = 0;
  public endDegree = 0;
  public attend_today: any = [];
  public attend_yesterday: any = [];
  public feedBack: any;

  public showAE = false;
  public showAC = false;
  public showLeave = false;
  public showShift = false;
  public showOvt = false;
  public showAL = false;
  public showATTV = false;
  public isSF6 = false;
  public funcCheckAtt: any;
  public showOffline = false;
  public showBarcode = false;
  public showBST = false;
  public showMassLeave = false;
  public userId: any;
  public photoProfile: any;
  public name: any;
  public position: any;
  public sub: any;

  public company_id: any;
  public empname: String;
  public empno: String;
  public userEmpid: String;
  public subscriptions: Array<Subscription> = [];
  public subject: any;
  public today: any;
  public myDate: any;
  public active_date: any;
  public isHoliday: Boolean = false;
  public empId: string;
  public isSpinner: boolean;
  public statusAttendanceWeb: any;
  public isSetupAttendanceMachine: any = false;
  public isHR: any = false;
  public isRecordTime: boolean = false;
  // define setting attendance
  public takePhoto: any = 1; // 1 = true
  public isDisabled: boolean = false;
  public pages: Array<{ title: string, component: any, icon: any, show: boolean }>;
  public isCordova: boolean = false;
  public flag_inputStatus: any; //penting
  public progressRecord: any = this.translate.instant('Record Time');
  public SFGoStorage: any;
  public path: any;
  public oldPATHUrl: any;
  public newPATH: boolean = false;
  public newPATHUrl: any;
  public menus: Array<any> = [];
  public submenus: any = [];
  public versionApps: String;
  public isSkeleton: boolean = false;
  public flag: any = {
    showMenu: false,
  }

  dummyTime: any = [
    {
      date: moment(),
      startTime: null,
      startType: 'fingerprint',
      startUrl: null,
      endTime: null,
      endType: 'fingerprint',
      endUrl: null,
    },
    {
      date: moment(),
      startTime: moment(),
      startType: 'fingerprint',
      startUrl: 'assets/icon_new/fingerprint.svg',
      endTime: moment(),
      endType: 'selfie',
      endUrl: 'assets/images/kim.jpg',
    },
  ]

  public isGopathNew: boolean;
  public attendanceData: any;
  public showBreakBtn: boolean;
  public showABP = true;

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public alertService: AlertServiceProvider,
    public diagnostic: Diagnostic,
    public events: Events,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public permissionCheckProvider: PermissionCheckProvider,
    public platform: Platform,
    public sfattendanceApi: SFAttendanceApi,
    public storage: Storage,
    public toastService: ToastServiceProvider,
    public camera: Camera,
    public alertCtrl: AlertController,
    public storagePathProvider: StoragePathProvider,
    public translate: TranslateService,
    public settingServiceApi: SettingServiceApi,
    public settingServiceNestApi: SettingApi,
    public customPlugin: CustomPluginProvider,
    public sunfishApi: SunfishApi,
    public attendanceBloc: AttendanceBloc,
    public analyticsProvider: AnalyticsProvider,
    public barcodeScanner: BarcodeScanner,
    public sfattendancesf6Api: SFAttendanceSF6Api,
    public transfer: FileTransfer,
    public ngZone: NgZone,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    private _pageBuilderSubmenuApiProvider: PageBuilderSubmenuApiProvider,
    public appVersion: AppVersion,
    public sfgoAuthService: SFGOAuthService,
    public pollingBloc: PollingBloc,
    public attendanceTempBloc: AttendanceTempBloc,
    public appPreferences: AttendanceTempBloc,
    public popoverCtrl: PopoverController,
    public attendaneFaceBloc: AttendanceFaceBloc,
    public profileBloc: ProfileBloc,
  ) {
    this.isCordova = this.platform.is('cordova') ? true : false;
    this.getDateToday();
    this.getBreakButton();
  }

  async ionViewDidLoad() {
    try {
      this.path = LoopBackConfig.getPath();
      this.SFGoAuth = await this.sfgoAuthService.getAuthorization();
      this.isGopathNew = await this.attendanceBloc.nestApiProvider.isGoPathNewExist();

      this.isSF6 = this.SFGoAuth.isSF6 == 1 ? true : false;
      this.company_id = this.SFGoAuth.companyId;
      this.empname = this.SFGoAuth.fullName;
      this.empno = this.SFGoAuth.empNo;
      this.userEmpid = this.SFGoAuth.empId;
      this.empId = this.navParams.get('empid') != undefined ? this.navParams.get('empid') : this.SFGoAuth.empId;
      this.isProfile = this.navParams.get('empid') != undefined ? false : true;
      this.attendaneFaceBloc.doGetNeedApproval();
      this.isHR = this.SFGoAuth.isHRAdmin || this.SFGoAuth.isAttAdmin;

      if (this.navParams.get('empid') != undefined) {
        await this.loadProfile(this.navParams.get('empid'));
      } else {
        this.userId = this.SFGoAuth.userId;
        this.photoProfile = this.SFGoAuth.photo;
        this.name = this.SFGoAuth.fullName;
        this.position = this.SFGoAuth.position;
      }

      await this.funcAuth();
      this.getMenus();
      await this.runEvents();
      await this.getSfGoStorage();
      await this.loadAttendanceMachine();
      await this.attendanceBloc.getCompanySetting();
      await this.loadVersionApps();
      this.attendanceBloc.params.setting = await this.attendanceBloc.getAttendanceSetting();
    } catch (error) {
      console.log('ionviewdidload error', error);
    }
  }

  async ionViewDidEnter() {
    this.isDisabled = false;

    try {
      await this.getCurrentTime();
      await this.checkAttendance();
      if (!_.isEmpty(this.navParams.data) && this.navParams.data.menuId) {
        await this.getSubmenus(this.navParams.data.menuId);
        if (this.submenus.length > 0) {
          this.replaceMenuExist();
        }

        this.flag.showMenu = true;
      } else {
        this.flag.showMenu = true;
      }

    } catch (error) {
      console.log('ionViewDidEnter', error);
    }
  }

  ionViewDidLeave(): any {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ionViewWillUnLoad() {
    this.events.unsubscribe('user:SFGoAttendanceOnlineLog');
  }

  async getDateToday() {
    const language = await this.storage.get('language');
    (language == 'id') ? moment.locale('id') : moment.locale('en');

    this.today = moment().format('ddd, DD MMM YYYY');
  }

  async getSfGoStorage(): Promise<any> {
    return new Promise((resolve) => {
      this.storage.ready().then(() => {
        this.storage.get('SFGoStorage').then(async (hasil) => {
          if (hasil != null && hasil != undefined) {
            this.SFGoStorage = JSON.parse(hasil);

            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin) {
              this.oldPATHUrl = this.SFGoStorage.storedPrelogin.GOPATH;
            } else {
              this.oldPATHUrl = this.path;
            }
            let path;
            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin &&
              this.SFGoStorage.storedPrelogin.hasOwnProperty('GOPATHNEW') && this.SFGoStorage.storedPrelogin.GOPATHNEW) {
              this.newPATH = true;
              path = this.SFGoStorage.storedPrelogin.GOPATHNEW;
              this.newPATHUrl = path;
            } else {
              this.newPATH = false;
            }
            // this.newPATHUrl = 'http://localhost:30000' // local nestjs;
            // this.newPATHUrl = 'http://localhost:5000' // local loopback;
            resolve(true);
          }
        });
      });
    });
  }


  async getSubmenus(parentId) {
    return new Promise(async (resolve, reject) => {
      this._pageBuilderSubmenuApiProvider.getSubmenu(parentId).then(response => {
        this.submenus = response;
        resolve(true);
      }, (error) => {
        resolve(error);
      });
    });
  }

  getMenus() {
    this.menus = [
      {
        title: 'Attendance List',
        icon: 'sficon-tasktime',
        action: 'attListPage',
        show: this.showAL,
      },
      {
        title: 'Attendance Correction',
        icon: 'sficon-chart',
        action: 'attCorrectionPage',
        show: this.showAC,
      },
      // {
      //   title: 'Attendance Base Photo',
      //   iconUrl: 'assets/icon_new/attendance/att-base-photo.svg',
      //   action: 'attBaseDashboardPage',
      //   show: this.showABP,
      //   totalAlet: 2
      // },
      {
        title: 'Leave',
        icon: 'sficon-persontime',
        action: 'leavePage',
        show: this.showLeave,
      },
      {
        title: 'Overtime',
        icon: 'sficon-briefcasetime',
        action: 'overtimePage',
        show: this.showOvt,
      },
      {
        title: this.isSF6 ? 'On Duty' : 'Business Trip',
        icon: 'sficon-businesstrip',
        action: 'businessPage',
        show: this.showBST,
      },
      {
        title: 'Shift Schedule',
        icon: 'sficon-shiftschedule',
        action: 'shiftPage',
        show: this.showShift,
      },
      {
        title: 'Request Shift Schedule',
        icon: 'sficon-shiftschedule',
        action: 'requestShiftSchedulePage',
        show: this.showShift,
      },
      // {
      //   title: 'Upload attendance data',
      //   icon: 'sficon-upload-machine',
      //   action: 'attendanceMachinePage',
      //   class: 'capitalize',
      //   show: this.isHR,
      // },
      {
        title: 'Mass Leave',
        icon: 'sficon-rounddash',
        action: 'massLeavePage',
        show: this.showMassLeave,
      },
      {
        title: 'Attendance Reprocess',
        icon: 'sficon-tasktime',
        action: 'modalAttendanceReprocess',
        show: this.isHR,
      },
      {
        title: 'Leave Balance Maintenance',
        icon: 'sficon-scales',
        action: 'modalLeaveBalanceMnt',
        show: this.isHR,
      },
      {
        title: 'Overtime Reprocess',
        icon: 'sficon-briefcasetime',
        action: 'overtimeReprocessPage',
        show: this.isHR,
      },
    ];

    this.flag.showMenu = true;
  }

  isImageFile(data: any): boolean {
    // TODO parsing data check apakah dia class atau file
    if (data.includes("http") || data.includes('assets/')) {
      return true;
    } else {
      return false;
    }
  }

  generateMenuIconUrl(rawPath: any): string {
    if (rawPath) {
      let result = rawPath.replace(new RegExp('{FILE_TOKEN}', 'g'), this.SFGoAuth.id);
      if (this.newPATHUrl != undefined && this.newPATHUrl != null) {
        result = result.replace(new RegExp('{PICTURE_PATH}', 'g'), this.newPATHUrl);
      } else {
        result = result.replace(new RegExp('{PICTURE_PATH}', 'g'), this.oldPATHUrl);
      }
      return result;
    }
    return rawPath;
  }

  replaceMenuExist(): void {
    this.menus.map(menu => {
      let submenuItem = this.submenus.filter(submenu => submenu.title === menu.title)[0];
      if (submenuItem) {
        menu.action = 'openPageBuilder';
        menu.pageBuilderId = submenuItem.pageBuilderId;
        menu.show = true;
        menu.iconUrl = this.generateMenuIconUrl(submenuItem.iconUrl);
        delete menu.icon;
        return menu;
      }
    });
  }

  async openPageBuilder(pageBuilderId) {
    try {
      await this.storage.ready();
      let hasil = await this.storage.get('SFGoAuth');
      if (hasil != null && hasil != undefined) {
        let SFGoAuth = JSON.parse(hasil);

        // let pageBuilderPages = await this.storage.get("pageBuilderPages");
        let version = await this.storage.get("version");

        let navParam = {
          pageId: pageBuilderId,
          pageTitle: 'Loading...',
          pageType: null,
          pageSchema: null,
          pageFile: null,
          pageParam: [],
          pageIsSub: false,
          userId: SFGoAuth.userId,
          static: null,
          cacheDuration: null,
          cacheStart: null,
          version: version,
        }

        this.storage.remove('pageActive');
        this.navCtrl.setRoot('InitPageBuilder', navParam);
      }
    } catch (error) {
      console.log(error);
    }
  }

  runEvents(): Promise<any> {
    return new Promise(async (resolve) => {
      this.events.subscribe('attendance:success-record-attendance', async (val) => {
        if (val) {
          await this.checkAttendance();
          resolve(true);
        }
      })
      resolve(true);
    })
  }

  getCurrentTime(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let time = await this.attendanceBloc.getCurrentTime();
        this.myDate = time;
        resolve(true);
      } catch (error) {
        resolve(true);
      }
    })
  }

  async checkAttendance(): Promise<any> {
    return new Promise(async (resolve) => {
      await this.getNewTodayAttendance();
      await this.getTodayShift();
      resolve(true)
    })
  }

  getTodayAttendance(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let result = await this.attendanceBloc.getTodayAttendance();
        if (result.success) {
          this.flag_inputStatus = result.result
          this.clockIn = result.result.starttime;
          this.clockOut = result.result.endtime;
          this.actualClockIn = result.result.actualIn;
          this.actualClockOut = result.result.actualOut;
          this.feedBack = result.result.feedback;
          if (this.clockIn != null) {
            let tempClockIn = moment(this.clockIn).subtract(moment().utcOffset(), 'minute').toISOString();
            this.startDegree = ((moment(tempClockIn).get('hours') * 60 + moment(tempClockIn).get('minute')) * 360) / 1440;
          }
          if (this.clockOut != null) {
            let tempClockOut = moment(this.clockOut).subtract(moment().utcOffset(), 'minute').toISOString();
            this.endDegree = ((moment(tempClockOut).get('hours') * 60 + moment(tempClockOut).get('minute')) * 360) / 1440;
          }
          if (this.feedBack !== null && this.feedBack !== undefined) {
            this.storage.get('rating').then(data => {
              if (data == null || data == undefined) {
                this.showRating();
              }
            })
          }
          this.btnDisabled = false;
        } else {
          this.btnDisabled = false;
        }
        resolve(true);
      } catch (error) {
        this.btnDisabled = false;
        resolve(true);
      }
    })
  }

  async getNewTodayAttendance() {
    this.isSkeleton = true;
    try {
      const params = {
        date: new Date().toISOString(),
        empId: this.empId
      }
      this.attendanceData = await this.attendanceTempBloc.getNewTodayAttendance(params);
      this.flag_inputStatus = this.attendanceData;
      this.feedBack = this.attendanceData.today.feedback || null;

      if (this.feedBack !== null && this.feedBack !== undefined) {
        const ratting = await this.storage.get('rating');
        if (ratting == null || ratting == undefined) {
          this.showRating();
        }
      }
      this.isSkeleton = false;
      this.btnDisabled = false;
    } catch (error) {
      this.btnDisabled = false;
      this.isSkeleton = false;
    }
  }

  getTodayShift(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let result = await this.attendanceBloc.getTodayShift()
        if (result.success) {
          this.newshiftname = result.result.shiftdailyname;
          this.newshiftcode = result.result.shiftdailycode;
          this.newshiftstart = result.result.shiftstarttime;
          this.newshiftend = result.result.shiftendtime;
          this.isHoliday = result.result.isHoliday;
        } else {
          this.newshiftname = null;
          this.newshiftcode = null;
          this.newshiftstart = null;
          this.newshiftend = null;
        }
        resolve(true);
      } catch (error) {
        this.newshiftname = null;
        this.newshiftcode = null;
        this.newshiftstart = null;
        this.newshiftend = null;
        resolve(true);
      }
    })
  }

  overtimeReprocessPage() {
    this.navCtrl.push('OvertimeReprocessSfgo')
  }

  leavePage() {
    this.isDisabled = true;
    this.navCtrl.push('leave2Page', { empid: this.empId, isProfile: this.isProfile });
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'leave');
  }

  attCorrectionPage() {
    this.isDisabled = true;
    this.navCtrl.push('AttdCorrectionHistoryPage', { empid: this.empId, isProfile: this.isProfile });
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'attendance correction');
  }

  attBaseDashboardPage() {
    this.navCtrl.push('AttBaseDashboardPage', { empId: this.empId, isProfile: this.isProfile });
  }

  btDeclarationPage() {
    this.navCtrl.push('BusinessTripDeclarationHistoryPage', { empid: this.empId, isProfile: this.isProfile });
  }

  attListPage() {
    this.isDisabled = true;
    if (this.empId == this.userEmpid) this.navCtrl.push('TimeAttendanceListNewPage', {
      empid: this.empId,
      isProfile: this.isProfile
    });
    if (this.empId != this.userEmpid) this.navCtrl.push('TimeAttendanceListDetailNewPage', {
      empid: this.empId,
      isProfile: this.isProfile,
      fromDetail: true
    });
  }

  attValidationPage() {
    this.navCtrl.push('AttendanceValidationPage', { empid: this.empId, isProfile: this.isProfile });
  }

  massLeavePage() {
    this.isDisabled = true;
    this.navCtrl.push('MassLeavePage', { empid: this.empId, isProfile: this.isProfile });
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'mass leave');
  }

  overtimePage() {
    this.isDisabled = true;
    this.navCtrl.push('OvertimeHistorySfgoPage', { empid: this.empId, isProfile: this.isProfile });
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'overtime');
  }

  businessPage() {
    this.isDisabled = true;
    this.navCtrl.push('BusinessTripPage', { empid: this.empId, isProfile: this.isProfile });
    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'business trip');
  }

  shiftPage() {
    this.isDisabled = true;
    this.navCtrl.push('ShiftscheduleformPage', {
      empid: this.empId,
      isProfile: this.isProfile,
      empname: this.empname,
      empno: this.empno
    });

    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'shift schedule');
  }

  requestShiftSchedulePage() {
    this.isDisabled = true;
    this.navCtrl.push('ListRequestShiftSchedulePage', {
      empId: this.empId,
      isProfile: this.isProfile,
      empName: this.empname,
      empNo: this.empno
    });
  }

  recordAttendanceWeb(event?: any) {
    this.attendanceBloc.processWebImage(event).then(data => {
      if (data) {
        this.redirectAttPreviewPage(data);
      } else {
        this.isRecordTime = false;
        this.isDisabled = false;
        this.progressRecord = this.translate.instant('Record Time');
      }
    })
  }

  async recordTimeBarcode() {
    if (this.platform.is('cordova')) {
      try {
        let data = await this.attendanceBloc.recordAttendanceBarcode(this.flag_inputStatus, false, this.myDate);
        if (data) {
          if (typeof data.mockDetect != 'undefined') {
            if (data.mockDetect) {
              this.navCtrl.push("ListBlockPackagePage", {
                packages: data.value
              });
            }
            return false;
          }
          this.events.publish('attendance:flag');
          this.events.publish('ATTENDANCE:RECORDATTENDANCEONLINE', data);
        }
        this.isRecordTime = false;
      } catch (error) {
        this.isRecordTime = false;
      }
    }
  }

  async checkPolling() {
    // const poll = await this.pollingBloc.getPollingFromStorage();
    // if (poll && poll.prompt == 'before_attendance') {
    //   if (poll.restrict) {
    //     this.navCtrl.setRoot("PollingWelcomePage", poll);
    //   } else {
    //     this.navCtrl.push("PollingWelcomePage", poll).then(() => {
    //       this.navCtrl.getActive().onDidDismiss(data => {
    //         if (!data) {
    //           this.recordTime();
    //         }
    //       });
    //     });
    //   }
    //   return true;
    // }
    this.recordTime();
  }

  async recordTime() {
    this.isRecordTime = true;
    if (this.platform.is('cordova')) {
      try {
        let result = await this.attendanceBloc.recordAttendance();
        if (result) {
          if (typeof result.mockDetect != 'undefined') {
            this.progressRecord = this.translate.instant('Record Time');
            this.isRecordTime = false;
            if (result.mockDetect) {
              this.navCtrl.push("ListBlockPackagePage", {
                packages: result.value
              });
            }
            return false;
          }

          this.redirectAttPreviewPage(result);
        } else {
          this.progressRecord = this.translate.instant('Record Time');
          this.isRecordTime = false;
        }
      } catch (error) {
        this.progressRecord = this.translate.instant('Record Time');
        this.isRecordTime = false;
      }
    } else {
      if (this.attendanceBloc.params.setting.takePhoto) {
        this.navCtrl.push('TimeAttendanceWebcamSfgoPage').then(() => {
          this.isRecordTime = false;
          this.navCtrl.getActive().onDidDismiss((data) => {
            if (data !== undefined) {
              this.recordAttendanceWeb(data);
            } else {
              this.progressRecord = this.translate.instant('Record Time');
              this.isRecordTime = false;
              this.isDisabled = false;
            }
          })
        })
      } else {
        this.recordAttendanceWeb();
      }
    }
  }

  async redirectAttPreviewPage(data: AttendancePreviewData) {
    if (this.SFGoAuth.companySetting && this.SFGoAuth.companySetting.covid19Zone) {
      try {
        const attendanceZone = await this.attendanceBloc.covid19ZoneApi(data.geolocation);
        await this.navCtrl.setRoot("AttAlertRedZonePage", { attendanceData: data, attendanceZone: attendanceZone });
      } catch (error) {
        this.attendanceBloc.nestApiProvider.responseError(error);
      }
    } else {
      await this.navCtrl.push('TimeAttendancePreviewSfgoPage', { data: data });
    }

    this.isRecordTime = false;
    this.isDisabled = false;
    this.progressRecord = this.translate.instant('Record Time');
  }


  async funcAuth(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let listMenu = this.SFGoAuth.menu;
        if (listMenu == undefined) {
          this.showAE = false;
          this.showAC = false;
          this.showLeave = false;
          this.showShift = false;
          this.showOvt = false;
          this.showAL = false;
          this.showATTV = false;
          this.showOffline = false;
          this.showBarcode = false;
          this.showBST = false;
          this.showMassLeave = false;
          this.showABP = false;
        } else {
          this.showAE = listMenu["att-entry"];
          this.showAC = listMenu["att-correction"];
          this.showLeave = listMenu["att-leave"];
          this.showShift = listMenu["att-shift"] || this.SFGoAuth.isAttAdmin ? true : false;
          this.showOvt = listMenu["att-overtime"];
          this.showAL = listMenu["att-list"];
          this.showATTV = listMenu["att-validation"];
          this.showOffline = listMenu["att-offline"];
          this.showBarcode = listMenu["att-barcode"];
          // this.showABP = listMenu["att-base-photo"];
          this.showBST = listMenu["bst-request"];
          this.showMassLeave = listMenu["mass-leave"];
        }
        resolve(true);
      } catch (error) {
        this.showAE = false;
        this.showAC = false;
        this.showLeave = false;
        this.showShift = false;
        this.showOvt = false;
        this.showAL = false;
        this.showATTV = false;
        this.showOffline = false;
        this.showBarcode = false;
        this.showBST = false;
        this.showMassLeave = false;
        this.showABP = false;
        resolve(true);
      }
    });
  }

  formatDate() {
    let d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('');
  }

  makeid() {
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    for (let i = 0; i < 12; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  offlineAttendance() {
    this.isDisabled = true;
    this.navCtrl.push('OfflineModeListPage');
  }

  funRunCheckWebabsent() {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.settingServiceApi.checkWebabsent().subscribe((val) => {
          if (val) {
            resolve(true)
          } else {
            this.fileInput.nativeElement.value = "";
            let msg = "error_message:Can't be absent through the web";
            this.alertService.createWarnMola(msg).then((result) => {
              this.alertService.redirect(msg)
            })
          }
        }, error => {
          this.fileInput.nativeElement.value = "";
          let msg = 'error_message:Error when checking';
          this.alertService.createWarnMola(msg).then((result) => {
            this.alertService.redirect(error.message)
          })
        })
      );
    })
  }

  attendanceMachinePage() {
    this.isDisabled = true;
    if (this.isSetupAttendanceMachine) {
      this.navCtrl.push("AttendanceMachineUploadPage");
    } else {
      this.navCtrl.push("AttendanceMachineSetupPage");
    }
  }

  async loadAttendanceMachine() {
    this.isHR = this.SFGoAuth.isHRAdmin || this.SFGoAuth.isAttAdmin;
    // show menu upload attendance if hr is true
    let idx = this.menus.findIndex((menu) => menu.action == 'attendanceMachinePage');
    this.menus[idx].show = this.isHR;

    const modalAttendanceReprocess = this.menus.findIndex((menu) => menu.action == 'modalAttendanceReprocess');
    this.menus[modalAttendanceReprocess].show = this.isHR;

    const modalLeaveBalanceMnt = this.menus.findIndex((menu) => menu.action == 'modalLeaveBalanceMnt');
    this.menus[modalLeaveBalanceMnt].show = this.isHR && !this.platform.is('cordova');

    const overtimeReprocessPage = this.menus.findIndex((menu) => menu.action == 'overtimeReprocessPage');
    this.menus[overtimeReprocessPage].show = this.isHR;

    if (this.isHR) {
      await this.loadAttendanceUpload();
    }
  }

  loadAttendanceUpload(): Promise<any> {
    return new Promise((resolve) => {
      this.subscriptions.push(
        this.settingServiceNestApi.attendanceUpload()
          .map(res => res.data)
          .subscribe((val) => {
            this.isSetupAttendanceMachine = val;
            resolve(true);
          }, error => {
            this.isSetupAttendanceMachine = false;
            resolve(true);
          })
      );
    })
  }

  //run attendance offline
  runAttendanceOffline(item) {
    if (this.platform.is('cordova')) {
      let alert = this.alertCtrl.create({
        message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" /><h6 style="color:#808080;">` +
          this.translate.instant('Do you want to keep the record offline?') + `</h6>`,
        enableBackdropDismiss: false,
        buttons: [{
          text: this.translate.instant('Cancel'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('OK'),
          handler: () => {
            this.saveAttedanceOffline(item);
          }
        }]
      });
      alert.present();
    }
  }

  //save attendance offline
  saveAttedanceOffline(item) {
    this.storage.get('SFGoAttendanceLog').then((attendance) => {
      if (attendance != null && attendance != undefined) {
        let data = JSON.parse(attendance);
        data.push(item);
        this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
      } else {
        let data = [];
        data.push(item);
        this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
      }
      const alert = this.alertCtrl.create({
        message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" /><h6 style="color:#808080;">` +
          this.translate.instant('Your attendance record is already saved') + `</h6>`,
        enableBackdropDismiss: false,
        buttons: [{
          text: 'Dismiss',
          handler: () => {

          }
        }]
      });
      alert.present();
    });
  }
  close() {
    if (this.viewCtrl) this.viewCtrl.dismiss();
  }

  showRating() {
    let modal = this.modalCtrl.create("RatingModalPage", {}, {
      cssClass: "grd-modal-rating",
      showBackdrop: true,
      enableBackdropDismiss: true
    });
    modal.present();
  }

  async loadProfile(empId: string): Promise<any> {
    try {
      const payload: RequestGetEmpDto = {
        empId: empId,
        userId: '',
        flag: 1
      }

      let result = await this.profileBloc.getEmp(payload);
      this.userId = result.userId;
      this.photoProfile = result.photo;
      this.name = result.fullName;
      this.position = result.posNameEn;
    } catch (error) {

    }
  }

  async loadVersionApps() {
    await this.platform.ready()
    let device = this.platform.is('cordova');
    if (device) {
      let name = await this.appVersion.getVersionNumber()
      let code = await this.appVersion.getVersionCode()
      this.versionApps = `ver. ${name} - ${code}`;
    } else {
      this.versionApps = "ver. web";
    }
  }

  async modalAttendanceReprocess() {
    if (this.platform.is('android') || this.platform.is('ios')) {
      await this.navCtrl.push('AttendanceReprocess');
    } else {
      const modal = this.modalCtrl.create('AttendanceReprocess', {}, { cssClass: "grd-modal-thin" });
      modal.onDidDismiss(data => {
        console.log('data', data);
      });
      await modal.present();
    }
  }

  async modalLeaveBalanceMnt() {
    if (this.platform.is('android') || this.platform.is('ios')) {
      await this.navCtrl.push('LeaveBalanceMaintenance');
    } else {
      const modal = this.modalCtrl.create('LeaveBalanceMaintenance', {}, { cssClass: "grd-modal-thin" });
      await modal.present();
    }
  }

  slideChanged() {
    let isEnd = this.slides.isEnd();
    let isBeginning = this.slides.isBeginning();
    if (isEnd) {
      this.toggleNext = false;
    } else if (!isEnd) {
      this.toggleNext = true;
    }
    if (isBeginning) {
      this.togglePrev = false;
    } else if (!isBeginning) {
      this.togglePrev = true;
    }
  }

  nextSlide() {
    this.slides.slideNext();
  }

  prevSlide() {
    this.slides.slidePrev();
  }

  showLog(params: { data: any, flag: 'today' | 'yesterday', empId?: any, attendDate?: any }) {
    params.empId = this.SFGoAuth.empId;
    params.attendDate = params.flag == 'today' ? moment().toISOString() : moment().startOf('day').add(moment().utcOffset(), 'minutes').subtract(1, 'day').toISOString();
    let modal = this.modalCtrl.create("TimeAttendanceLogPage", { paramPage: params });
    modal.present();
  }

  async getBreakButton() {
    try {
      const showBreakBtn = await this.attendanceBloc.getBreakButtonGD();
      this.attendanceBloc.setShowBreakTime(showBreakBtn.showButton);
    } catch (error) {
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/hr/time-attendance/sfgo/time-attendance-sfgo/time-attendance-sfgo.ts